import styled from 'styled-components';

export const DeviceLabel = styled.div`
	font-size: 12px;
	font-weight: 200;
	color: ${({ theme }) => theme.gray[1000]};
	margin-top: 10px;
	margin-bottom: 3px;
`;

export const LilSpacer = styled.div`
	height: 12px;
`;
